import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ModalRef } from '@app/core/services/core-modal.service';

export interface IEidosAlertDialogData {
  title?: string;
  info: string;
}

@Component({
  selector: 'eidos-alert-dialog',
  styleUrls: [
    'eidos-alert-dialog.component.scss'
  ],
  templateUrl: 'eidos-alert-dialog.component.html'
})
export class EidosAlertDialogComponent implements OnInit, OnDestroy {
  @Input() modalRef!: ModalRef;
  @Input() modalData!: IEidosAlertDialogData;

  constructor() {
  }

  ngOnInit(): void {
  }

  close(): void {
    this.modalRef.close();
  }

  ngOnDestroy() {
  }
}
